export default __webpack_public_path__ + "static/sparkasse-de52a8708549c0ff61dfb063cec55092.jpg";